export const toastedOptions = {
  Error: {
    position: 'top-center',
    type: 'error',
    duration: 2500,
    iconPack: 'fontawesome',
    icon: 'times-circle'
  },
  Success: {
    position: 'top-center',
    type: 'success',
    duration: 1500,
    iconPack: 'fontawesome',
    icon: 'check-circle'
  },
  Info: {
    position: 'top-center',
    type: 'info',
    duration: 1500,
    iconPack: 'fontawesome',
    icon: 'info-circle'
  }
};
/*
export function toastedOptions( type ){
  console.log('--------------------------------------------');
  console.log(type);
  console.log(options);
  return options[type];
}
*/